import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HelpIcon from '@mui/icons-material/Help';
import './styles/NavMenu.css';
import { req } from './ServerUtils';
import { useEffect } from 'react';
import { getRecency } from './Chat2';
import { useNavigate } from 'react-router-dom';

export function ProjectMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [conversations, setConversations] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    req('/conversations').then((res) => {
      console.log("Recent conversations", res);
      setConversations(res);
      const newChatMenuItem = {
        icon: <DashboardIcon />,
        label: 'New Chat',
        onClick: () => {
          console.log('Navigate to dashboard');
          navigate(`/chat`);
          handleClose();
        },
      };
      setMenuItems([newChatMenuItem,...res.map((conversation) => ({
        icon: <DashboardIcon />,
        label: conversation.title || "Chat from " + getRecency(conversation.created_at),
        onClick: () => {
          console.log('Navigate to conversation', conversation.conversation_id);
          navigate(`/chat/${conversation.conversation_id}`);
          handleClose();
        },
      }))]);
    }).catch((error) => {
      console.log("Error getting recent conversations", error);
    });
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const menuItems = [
  //   {
  //     icon: <DashboardIcon />,
  //     label: 'New Chat',
  //     onClick: () => {
  //       console.log('Navigate to dashboard');
  //       handleClose();
  //     },
  //   },
  //   {
  //     icon: <DriveFileRenameOutlineIcon />,
  //     label: 'Rename project',
  //     onClick: () => {
  //       console.log('Rename project');
  //       handleClose();
  //     },
  //   },
  //   {
  //     icon: <SettingsIcon />,
  //     label: 'Project Settings',
  //     onClick: () => {
  //       console.log('Open project settings');
  //       handleClose();
  //     },
  //   },
  //   {
  //     icon: <AccountCircleIcon />,
  //     label: 'Account Settings',
  //     onClick: () => {
  //       console.log('Open account settings');
  //       handleClose();
  //     },
  //   },
  //   {
  //     icon: <HelpIcon />,
  //     label: 'Help',
  //     onClick: () => {
  //       console.log('Open help');
  //       handleClose();
  //     },
  //   },
  // ];

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls={open ? 'project-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className="project-menu-button"
      >
        <KeyboardArrowDownOutlinedIcon sx={{fontSize: "18px" , color: "white"}} />
      </IconButton>
      <Menu
        id="project-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="styled-menu"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {menuItems.map((item, index) => (
          <MenuItem
            key={index}
            onClick={item.onClick}
            className="menu-item"
          >
            {item.icon}
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export function ProjectHeader() {
  return (
    <div className="project-header">
      <div className="project-title">
        <span>❤️</span>
        <span className="project-name">Assistant</span>
      </div>
      <ProjectMenu />
    </div>
  );
}